import { DocumentNode, gql } from '@apollo/client';
import { Tooltip, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { useListOfAuthors } from '@/components/Post/components/LikeCommentFooter/hooks/useListOfAuthors';
import { RespondButton } from '@/components/Post/components/RespondButton';
import { ThumbsUpIcon } from '@/imports/ui/chakra/feather';

import { LikeCount_CommentFragment } from './graphql-types/LikeCount_CommentFragment';

import { CommentLikesModal } from './components';

export const LikeCount: React.FC<{ comment: LikeCount_CommentFragment }> & {
  commentFragment: DocumentNode;
} = ({ comment }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const listOfAuthorsWhoLiked = comment.reactions
    .map((reaction) => reaction.user?.displayName)
    .filter((displayName): displayName is string => !!displayName);

  const { readableListOfAuthors } = useListOfAuthors(listOfAuthorsWhoLiked, 6);
  return (
    <>
      <CommentLikesModal
        commentId={comment._id}
        isOpen={isOpen}
        onClose={onClose}
      />

      <Tooltip
        label={readableListOfAuthors}
        isDisabled={!comment.reactionCount}
        placement="top"
        p="2"
      >
        <RespondButton
          onClick={
            !comment.reactionCount || comment.reactionCount === 0
              ? undefined
              : onOpen
          }
          color="gray.600"
          leftIcon={<ThumbsUpIcon />}
          size="sm"
        >
          {comment.reactionCount || 0}
        </RespondButton>
      </Tooltip>
    </>
  );
};

LikeCount.commentFragment = gql`
  fragment LikeCount_CommentFragment on Comment {
    _id
    reactionCount
    reactions {
      _id
      user {
        _id
        displayName
      }
    }
  }
`;
